import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    groups: null,
    groupsData: null,
    statusBtn: [
      { text: 'Verleih', value: -1, color: '#aaaaaa', count: 0, dis: true },
      { text: 'Antrag U / G', value: 1, color: '#ed2c2c', count: 0, dis: true },
      { text: 'Dienstreise', value: 2, color: '#e39a2b', count: 0, dis: true },
      { text: 'Gleitzeit', value: 3, color: '#ece509', count: 0, dis: true },
      { text: 'KoL', value: 9, color: '#add11c', count: 0, dis: true },
      { text: 'Home-Office', value: 4, color: '#4fd854', count: 0, dis: true },
      { text: 'Krank', value: 5, color: '#24cfe5', count: 0, dis: true },
      { text: 'Kurzarbeit', value: 6, color: '#6276e4', count: 0, dis: true },
      { text: 'Urlaub', value: 7, color: '#c837e1', count: 0, dis: true },
      { text: 'Frei', value: 8, color: '#444', count: 0, dis: true },
    ],
    dayStatus: 0,
  },
  getters: {
    statusBtn: (state) => state.statusBtn,
    dayStatus: (state) => state.dayStatus,
    statusBtnColor: (state) => (status) => {
      return state.statusBtn.find((btn) => btn.value == status).color
    },

    groups: (state) => state.groups,
    groupsData: (state) => state.groupsData,
    groupColor: (state) => (id) => {
      let group = state.groups.find((group) => group.id == id)
      return group ? group.color : '#ffffff'
    },
  },
  mutations: {
    setGroups: (state, groups) => (state.groups = groups),
    setGroupsData: (state, groups) => (state.groupsData = groups),
    setDayStatus: (state, value) => (state.dayStatus = value),
    statusBtnRight(state, data) {
      state.statusBtn.forEach((btn) => {
        if (
          (btn.value != -1 &&
            btn.value != 2 &&
            btn.value != 3 &&
            btn.value != 7) ||
          data.path != '/time/userview'
        ) {
          if (data.right & 8) {
            btn.dis = false
          } else if (data.right & 4) {
            if (btn.value != -1 && btn.value != 3 && btn.value != 7)
              btn.dis = false
          }
        } else btn.dis = true // reset
      })
    },
  },
  actions: {
    async loadGroups({ commit, getters }) {
      if (getters.groups === null)
        await Vue.prototype.$axios.get('time/groupswithusers').then((res) => {
          commit('setGroups', res.data)
        })
      if (getters.groupsData === null)
        await Vue.prototype.$axios.get('time/groupsdata/none').then((res) => {
          commit('setGroupsData', res.data)
        })
    },
  },
  modules: {},
}
